<template>
  <div :style="dependenciesComponentsStyleList">
    <v-progress-circular
      :size="preloaderData.size"
      :width="preloaderData.width"
      indeterminate
      class="primary--text d-block mb-6 mx-auto"
    />
    <div class="text-body-1 text--text text-center">
      Бронируем время на 20 минут...
    </div>
  </div>
</template>

<script>
import { ClubStyleData } from 'www/vue_components/common/Club/mixins'

export default {
  name: 'ClubAppointmentPreloader',
  mixins: [
    ClubStyleData,
  ],
}
</script>
